import { render, staticRenderFns } from "./WineDiscountTooltip.vue?vue&type=template&id=80b7c004&scoped=true"
import script from "./WineDiscountTooltip.vue?vue&type=script&lang=js"
export * from "./WineDiscountTooltip.vue?vue&type=script&lang=js"
import style0 from "./WineDiscountTooltip.vue?vue&type=style&index=0&id=80b7c004&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7c004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b7c004')) {
      api.createRecord('80b7c004', component.options)
    } else {
      api.reload('80b7c004', component.options)
    }
    module.hot.accept("./WineDiscountTooltip.vue?vue&type=template&id=80b7c004&scoped=true", function () {
      api.rerender('80b7c004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineDiscountTooltip.vue"
export default component.exports